import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import AddIcon from "@mui/icons-material/Add";
import Paper from "@mui/material/Paper";
import {
  collection,
  getDocs,
  doc,
  query,
  orderBy,
  onSnapshot,
  deleteDoc,
  setDoc,
  limit,
  startAfter,
  where,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { db, storage } from "../../firebase";
import MyPopover from "../Popover";
import { useSnackbar } from "notistack";
import { deleteObject, ref } from "firebase/storage";
import {
  Box,
  Button,
  InputAdornment,
  Switch,
  TableFooter,
  TextField,
} from "@mui/material";
import Selector from "./Selector";
import { sOnOff, sOperate, sProducts } from "../Strings";
import ProductView from "./ProductView";
import { Search } from "@mui/icons-material";
import { usePagination } from "../../hooks/pagination/usePagination";

export default function ProductList() {
  const [category, setCategory] = useState([]);
  const categoryRef = query(collection(db, "category"), orderBy("name"));
  const { enqueueSnackbar } = useSnackbar();

  const [search, setSearch] = useState(null);

  // initial query state
  const [customQuery, setCustomQuery] = useState(orderBy("timestamp", "desc"));

  // set custom search query
  useEffect(() => {
    // search empty string as well
    if (search || search == "")
      setCustomQuery(
        where("keywords", "array-contains", search.trim().toLowerCase())
      );
  }, [search]);

  // SET CUSTOM QUERY
  const productRef = query(collection(db, sProducts), customQuery, limit(10));

  //  Update the search value
  const handleChange = (event) => {
    setSearch(event.target.value);
  };

  const [open, setOpen] = React.useState(false);
  const [row, setRow] = React.useState([]);

  const handleOpen = (row) => {
    setOpen(true); // open drawer
    setRow(row); // send data to drawer
  };

  const handleClose = () => setOpen(false);

  // custom pagination hook
  const { fetchMore, paginatedList, setList, getList } =
    usePagination(productRef);

  // const [productRef, setProductRef] = useState(productRef1);
  // const productRef = query(collection(db, sProducts), orderBy("name"));

  // get products from collection
  useEffect(() => {
    getList();
  }, [customQuery]);

  // get all categories
  useEffect(() => {
    getDocs(categoryRef).then((snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setCategory(data);
    });
  }, []);

  function Row(props) {
    const { row } = props; // get row data

    // action button options
    const options = [
      {
        name: "Edit",
        status: 2,
      },
      {
        name: "Delete",
        status: 1,
      },
    ];
    // create product document ref
    const productRef = doc(db, sProducts, row.id);

    const deleteImages = (urls) => {
      // delete each image in array
      for (const imageUrl of urls) {
        const imageRef = ref(storage, imageUrl);
        const del = deleteObject(imageRef);
      }
      return deleteProduct();
    };

    const deleteProduct = () => {
      // delete document
      deleteDoc(productRef).then(() => {
        // remove object from product list
        var array = paginatedList.filter((v) => v.id !== row.id);
        setList(array);

        console.log("Deleted");
        enqueueSnackbar("Product Deleted!", { variant: "success" });
      });
    };

    function UpdateStatus(id) {
      if (id === 1) {
        deleteImages(row.imageURL); // delete option
      } else if (id === 2) {
        handleOpen(row); // edit option
      }
    }

    function updateProductStatus(checked) {
      let i = 1;
      if (checked) i = 0;
      setDoc(productRef, { status: i }, { merge: true }).then(() => {
        enqueueSnackbar("State Updated!", { variant: "success" });
        console.log("Document updated ", row.id);
      });
    }

    function ControlledSwitches() {
      const [checked, setChecked] = React.useState(true);

      const handleChange = (event) => {
        setChecked(event.target.checked);
        // pass state
        updateProductStatus(event.target.checked);
      };

      useEffect(() => {
        // if product status is hidden
        if (row.status === 1) setChecked(false);
      }, []);

      return (
        <Switch
          checked={checked}
          onChange={handleChange}
          inputProps={{ "aria-label": "controlled" }}
        />
      );
    }

    return (
      <TableRow
        hover
        sx={{
          "&:last-child td, &:last-child th": { border: 0 },
          cursor: "pointer",
        }}
        // onClick={() => handleOpen(row)}
      >
        <TableCell component="th" scope="row" onClick={() => handleOpen(row)}>
          {row.name}
          <div style={{ fontSize: 11, color: "GrayText" }}>
            {row.desc && row.desc}
          </div>
        </TableCell>
        <TableCell align="right" onClick={() => handleOpen(row)}>
          {row.price}
        </TableCell>
        <TableCell align="right" onClick={() => handleOpen(row)}>
          {row.dFee}
        </TableCell>

        <TableCell align="right">
          {/* On-Off Switch */}
          <ControlledSwitches />
        </TableCell>
        <TableCell align="right">
          <MyPopover onClick={UpdateStatus} options={options} />
        </TableCell>
      </TableRow>
    );
  }

  // Main View
  return (
    <div>
      {/* Filter View */}
      <Box sx={{ width: "100%" }}>
        <Selector onSelect={setList} />

        <Button
          onClick={() => handleOpen(null)}
          variant="outlined"
          disableElevation
          startIcon={<AddIcon />}
          sx={{
            width: 150,
            height: 38,
            fontSize: 12,
            borderRadius: 1,
            mt: 1,
            mb: 1,
          }}
        >
          Add Product
        </Button>
      </Box>
      {/* search bar */}
      <TextField
        sx={{ mt: 3 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        }}
        placeholder="Search products"
        type="search"
        fullWidth
        variant="outlined"
        onChange={handleChange}
      />

      <TableContainer
        sx={{
          my: 4,

          // overflowX: "initial",
          border: "1px solid #ccc",
          borderRadius: 3,
        }}
      >
        <Table sx={{ minWidth: 650 }} stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Product Name</TableCell>
              <TableCell align="right">Price (SSP)</TableCell>
              <TableCell align="right">Delivery (SSP)</TableCell>
              <TableCell align="right">{sOnOff}</TableCell>
              <TableCell align="right">{sOperate}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedList.map((row, key) => (
              <Row row={row} key={key} />
            ))}
          </TableBody>
          {paginatedList.length === 0 && (
            <TableFooter>
              <TableRow>
                <TableCell align="center">Nothing available</TableCell>
              </TableRow>
            </TableFooter>
          )}
        </Table>
      </TableContainer>

      <Button onClick={fetchMore} variant="contained" disableElevation>
        Load More (+10)
      </Button>
      <ProductView
        open={open}
        row={row}
        handleClose={handleClose}
        category={category}
      />
    </div>
  );
}
